import api from "api";
import ApiCaller from "api/apiCaller";
import LayoutItem from "components/LayoutItem";
import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import t from "utils/Lang";
import "./index.scss";

type ModalStatusProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  id?: number;
  user: any;
  onClosed: () => void;
  onUpdated: (status: any) => void;
  onCreated: (status: any) => void;
  coordinate?: any;
  listRoles: Array<any>;
  statusRoles: Array<any>;
  selectedType: any;
};

const ModalStatus = ({
  isOpen,
  toggle,
  id,
  user,
  onClosed,
  onUpdated,
  onCreated,
  coordinate,
  listRoles,
  statusRoles,
  selectedType,
}: ModalStatusProps) => {
  const [statusData, setStatusData] = useState<any>({
    content_type: selectedType.value,
    is_active: true,
    is_show_on_progress_bar: true,
    status_roles: statusRoles,
    status_default_role_assignment: [],
  });
  const getStatusData = async () => {
    if (!id) {
      setStatusData({
        content_type: selectedType.value,
        is_active: true,
        is_show_on_progress_bar: true,
        status_roles: statusRoles,
      });
      return;
    }
    const statusRes = await ApiCaller.get(`status/${id}`);
    if (statusRes.statusCode == 200) {
      setStatusData({
        ...statusRes.result,
        status_roles: statusRoles,
        status_default_role_assignment:
          statusRes.result?.status_default_role_assignment?.map(
            (role_assignment: any) => ({
              label: role_assignment.name,
              value: role_assignment.id,
            })
          ),
      });
    }
  };
  useEffect(() => {
    if (isOpen) getStatusData();
  }, [isOpen]);
  const uiLayoutDefinition = [
    {
      attributeName: "brand",
      type: "text",
      data: user?.user_brand?.brand_name,
      label: "Brand",
      disabled: true,
    },
    {
      attributeName: "name",
      type: "text",
      label: t().setting_status__name,
    },
    {
      attributeName: "code",
      type: "text",
      label: "Code",
      disabled: !!id,
    },
    {
      attributeName: "content_type",
      type: "dropdown",
      label: t().setting_status__type,
      options: [
        { value: "site", label: "site" },
        { value: "store", label: "store" },
      ],
      disabled: true,
    },
    {
      attributeName: "order_sequence_number",
      type: "number",
      label: t().setting_status__order,
    },
    {
      attributeName: "status_roles",
      type: "dropdown",
      label: t().setting_status__role_can_update,
      options: listRoles.map((role) => ({ label: role.name, value: role.id })),
      isMultiple: true,
    },
    {
      attributeName: "status_default_role_assignment",
      type: "dropdown",
      label: t().setting_status__role_default_assignment,
      options: listRoles.map((role) => ({ label: role.name, value: role.id })),
      isMultiple: true,
    },
    {
      attributeName: "is_active",
      type: "check",
      label: "Active status",
    },
    {
      attributeName: "is_show_on_progress_bar",
      type: "check",
      label: t().setting_status__show_on_progress_bar,
    },
    {
      attributeName: "is_default_site_status",
      type: "check",
      label: t().setting_status__site_status_default,
    },
    {
      attributeName: "is_default_store_status",
      type: "check",
      label: t().setting_status__store_status_default,
    },
    {
      attributeName: "is_site_can_edit",
      type: "check",
      label: t().setting_status__site_can_edit,
    },
    {
      attributeName: "button_background_color",
      type: "text",
      label: "Button background color",
    },
    {
      attributeName: "button_icon",
      type: "text",
      label: "Button icon",
    },
    {
      attributeName: "button_text",
      type: "text",
      label: "Button text",
    },
  ];
  const updateAtt = (att: string, val: any) => {
    let value = val;
    if (typeof val == "object") {
      if (val?.length > 0) {
        // good
      } else {
        value = val.value;
      }
    }
    setStatusData((statusData: any) => {
      if (statusData) {
        return {
          ...statusData,
          [att]: value,
        };
      }
      return { [att]: value };
    });
  };
  const onUpdateStatus = async () => {
    const body = { ...statusData };
    delete body.status_roles;
    const res = await ApiCaller.put(`status/${id}`, statusData);
    if (res.statusCode == 200) {
      onUpdated({ ...res.result, id });
    } else if (res.message) {
      alert(res.message);
    }
  };
  const onCreateStatus = async () => {
    const body = {
      ...statusData,
      ...coordinate,
      brand: { id: user?.user_brand?.brand_id },
    };
    const statusRoles = body.status_roles;
    delete body.status_roles;
    const res = await ApiCaller.post(`status/`, body);
    if (res.result) {
      statusRoles.forEach((statusRole: any) => {
        api.toggleStatusRole({
          status_id: res.id,
          role_id: statusRole.value,
          is_delete: false,
        });
      });
      onCreated({ ...res.result, id: res.id });
    } else if (res.message) {
      alert(res.message);
    }
  };
  const onSave = async () => {
    if (!statusData.code || !statusData.name) {
      alert("Có lỗi xảy ra");
      return;
    }
    if (id) {
      await onUpdateStatus();
    } else {
      await onCreateStatus();
    }
    toggle();
  };
  const onItemChanged = (att: string, item: any, isSelected: boolean) => {
    if (att == "status_roles" && !!id) {
      const body = {
        status_id: id,
        role_id: item.value,
        is_delete: !isSelected,
      };
      api.toggleStatusRole(body);
    }
    if (att == "status_default_role_assignment" && !!id) {
      const body = {
        status_id: id,
        role_id: item.value,
        is_delete: !isSelected,
      };
      api.toggleStatusDefaultRoleAssignment(body);
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ padding: 30 }}
      onClosed={onClosed}
    >
      <div className="modal-status__header">
        <span className="modal-status__header__title">
          {id ? t().setting_status__edit : t().setting_status__create_new}
        </span>
      </div>
      <div className="modal-status__body">
        {uiLayoutDefinition.map((item) => (
          <LayoutItem
            item={item}
            statusData={statusData}
            callback={updateAtt}
            onItemChanged={onItemChanged}
            key={item.attributeName}
          />
        ))}
      </div>
      <div className="modal-status__footer">
        <div className="modal-status__confirm-button" onClick={onSave}>
          <span>{t().action__done}</span>
        </div>
      </div>
    </Modal>
  );
};

export default ModalStatus;
